import React, { useState } from 'react';
import Masonry from 'react-masonry-css';
import OrderCard from '../OrderCard';

function OrdersNew({ baskets, setBaskets, kdsViewMode, kds, kds_index }) {
  const breakpointColumnsObj = {
    default: kdsViewMode,
    1100: 3,
    700: 2,
    500: 1,
  };

  const [disableButtonSubmit, setDisableButtonSubmit] = useState([]);

  return (
    <Masonry
      breakpointCols={breakpointColumnsObj}
      className="my-masonry-grid"
      columnClassName="my-masonry-grid_column"
    >
      {baskets?.length > 0 &&
        baskets
          ?.filter(
            (item) =>
              (item.status === 'pending' || item.status === 'doing') &&
              item.is_active
          )
          .map((item) => (
            <OrderCard
              item={item}
              baskets={baskets}
              setBaskets={setBaskets}
              key={item.id}
              kds={kds}
              kds_index={kds_index}
              setDisableButtonSubmit={setDisableButtonSubmit}
              disableButtonSubmit={disableButtonSubmit}
            />
          ))}
    </Masonry>
  );
}

export default OrdersNew;
